import { type ClassValue, clsx } from "clsx";
import { getYear } from "date-fns";
import { twMerge } from "tailwind-merge";
import type { SelectOption } from "@/lib/api.types";
import { describeServerError, readServerError } from "@/lib/server-errors";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function labelFor(
  options: SelectOption[] | undefined,
  value: string | null | undefined,
  fallback = "",
) {
  if (!value) return fallback;
  return options?.find((o) => o.value === value)?.label ?? value;
}

export function getYears(startOffset: number, endOffset: number) {
  const currentYear = getYear(new Date());
  const years = [];
  for (let y = currentYear - startOffset; y >= currentYear - endOffset; y--) {
    years.push({ value: String(y), label: String(y) });
  }
  return years;
}

export function parseDateOfBirth(iso: string | null) {
  if (!iso) return { month: "", day: "", year: "" };
  const [year, month, day] = iso.split("-");
  return { month, day, year };
}

/** Turns an API error into a display string; see `@/lib/server-errors`. */
export async function handleApiError(err: unknown): Promise<string> {
  return describeServerError(await readServerError(err));
}
